// src/components/ToonieTaste.js
import React from 'react';
import './ToonieTaste.css';
import Navbar from './Navbar';

const ToonieTaste = () => {
  return (
    <>
      <Navbar />

      <div className="toonie-section toonie-hero">
        <img
          src="/images/toonie/title.svg"
          alt="Toonie Taste"
          className="toonie-arch-title"
        />
        <p className="toonie-label">Dessert</p>
        <h1 className="toonie-name">Ovos Moles</h1>
        <p className="toonie-price">$2.00 CAD</p>

        <img
          src="/images/toonie/ovos-moles.png"
          alt="Ovos Moles"
          className="toonie-product-image"
        />

        <p className="toonie-description">
          <span className="highlight">Ovos moles de Aveiro</span> (literally "soft eggs from Aveiro") are a traditional pastry from the Aveiro District in Portugal, a delicacy deeply rooted in the region's conventual history.
        </p>

        <button className="toonie-button">KNOW MORE</button>

        <p className="toonie-presale">KNOW MORE ABOUT OUR SPONSORS </p>
        <p ><small>P.C.C.M.</small></p>
      </div>

      <div className="toonie-section toonie-video">
        <video
          className="toonie-video-embed"
          src="/videos/bowl-footage.mp4"
          autoPlay
          muted
          loop
          playsInline
        />
        <p className="toonie-video-text">
          Dating back to the 16th century, ovos moles were first created by nuns in convents like the Monastery of Jesus.
        </p>
      </div>

      <div className="toonie-section toonie-video">
        <video
          className="toonie-video-embed"
          src="/videos/egg-prep.mp4"
          autoPlay
          muted
          loop
          playsInline
        />
        <p className="toonie-video-text">
          According to legend, the nuns used egg whites to starch their habits or filter wine, and to avoid wasting the yolks, they mixed them with sugar, which was abundant due to Portugal’s sugarcane production in Madeira.
        </p>
      </div>

      <div className="toonie-section toonie-image-text">
        <img
          src="/images/toonie/hand-dessert.png"
          alt="Ovos moles in hand"
          className="toonie-full-image"
        />
        <p className="toonie-paragraph">
          This resulted in a rich, velvety mixture of egg yolks and sugar, encased in thin communion wafers or rice paper, shaped like shells, fish, or barrels — reflecting Aveiro's connection to the sea and its lagoon.
        </p>
      </div>

      <div className="toonie-section toonie-closing">
        <img
          src="/images/toonie/aveiro.png"
          alt="Aveiro City"
          className="toonie-full-image"
        />
        <p className="toonie-footer-caption">AVEIRO, PORTUGAL</p>
        <img
          src="/images/toonie/up-arrow.svg"
          alt="Scroll to top"
          className="toonie-scroll-icon"
        />
      </div>
    </>
  );
};

export default ToonieTaste;
